import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-row-information__text" }

import {computed} from 'vue';
    import {useGlobalProperties} from '@malt/vue3-use';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StepRowInformation',
  props: {
    mandatory: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const {$msg} = useGlobalProperties();

    const props = __props;
    const text = computed(() =>
        props.mandatory ? $msg('customer.brief.form.overview.field.required') : $msg('customer.brief.form.overview.field.missing'),
    );
    const iconColor = computed(() => (props.mandatory ? 'error' : 'secondary'));

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    "aria-hidden": "",
    class: _normalizeClass({'step-row-information__error': _ctx.mandatory})
  }, [
    _createVNode(_component_VJoyIcon, {
      name: "warning-triangle",
      color: iconColor.value,
      class: "step-row-information__icon"
    }, null, 8, ["color"]),
    _createElementVNode("span", _hoisted_1, _toDisplayString(text.value), 1)
  ], 2))
}
}

})